import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#10529e',
                secondary: '#4b982b',
                info: '#4583f4',
                success: '#8BC34A',
                error: '#e80028'
            },
            dark: {
                primary: '#10529e',
                secondary: '#4b982b',
                info: '#4583f4',
                success: '#8BC34A',
                error: '#e80028'
            }
        }
    }
});
